import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/beam-designer.css'

import { showBootstrapModal, hideBootstrapModal, setActivePill, initializeTooltips } from 'ws-app'

import { App, checkIsUpgraded, featureGate } from 'ws-app'

import { validateRequiredInput, validateLengthInput, validateGreaterThan } from 'ws-validation'
import { onEnglishUnitsClicked, onEnglishLbsUnitsClicked, onMetricUnitsClicked, wsParseLength } from 'ws-units'

import { makeVisitorBeam } from './project/beam-project.js'

import { drawBeamModel } from "./beam/beam-view.js"
import { drawResultsView } from "./results/beam-results-view.js"
import { showReactionSummary } from './results/beam-result-reaction-summary.js'
import { showResultPlots } from './results/beam-result-charts.js'
import { showDesignSummary } from "./results/design-summary-view.js";

import { BeamProject } from './project/beam-project.js'
import { DesignConfigurator } from './design/design-configurator.js'
import { BeamManager, BracingManager, LoadManager } from './beam/beam-managers.js'

import { asdCombinations, lrfdCombinations, noCombinations } from './load-combinations/load-combination.js'

import { suggestShape, shapeName } from './project/shape-finder.js'

import './web-components/print-preferences-component.js'
import './web-components/file-explorer-component.js'
import './web-components/file-export-component.js'
import './web-components/design-summary-component.js'
import './web-components/design-dialog-component.js'
import './web-components/span-dialog-component.js'
import './web-components/load-dialog-component.js'
import './web-components/bracing-dialog-component.js'

const app = new App('beam-designer')

let rtime = new Date(1, 1, 2e3, 12, 0, 0)
let timeout = false
let delta = 100

function resizeend() {
  new Date - rtime < delta ? setTimeout(resizeend, delta) : (timeout = !1, app.draw(app.activeProject))
} 

window.onresize = (() => { 
  rtime = new Date, 
  timeout === false && (timeout = true, setTimeout(resizeend, delta)) 
})

let gResults = []

const designConfigurator = new DesignConfigurator()

app.draw = (project, forPrint) => {
  if(typeof forPrint === 'undefined') {
    forPrint = false
  }
  configureResultCardVisibility(project, forPrint)
  drawBeamModel(project, forPrint)
  drawResultsView(project, gResults, forPrint)
  showReactionSummary(project, gResults)
  showResultPlots(project, gResults, forPrint)
}

function  configureResultCardVisibility(project) {
  // if design type is None, hide the Load Combinaation cards
  if(project.design.designType === 'None') {
    document.getElementById('load-combination-reactions-card').classList.add('d-none')
    document.getElementById('load-combination-plots-div').classList.add('d-none')
  } else {
    document.getElementById('load-combination-reactions-card').classList.remove('d-none')
    document.getElementById('load-combination-plots-div').classList.remove('d-none')
  } 
}

app.disablePrinting = () => {
  document.getElementById('footer').classList.remove('hidden-print');
  document.getElementById("result-view-section").classList.add('hidden-print')
  document.getElementById("design-summary-div").classList.add('hidden-print')
}

app.enablePrinting = () => {
  document.getElementById('footer').classList.add('hidden-print');
  document.getElementById("result-view-section").classList.remove('hidden-print')
  document.getElementById("design-summary-div").classList.remove('hidden-print')
}

app.deserialize = (json) => {
  return BeamProject.load(json)
}

app.newProject = () => {
  return BeamProject.makeSimpleNewProject()
}

app.openFileExplorer = () => {
  showBootstrapModal('modal-file-explorer-dialog')
}

app.copyProject = () => {
  return BeamProject.createCopy(app.activeProject.serialize())
}

app.onPrintProject = () => {
  if(featureGate()) { return }
  showBootstrapModal('modal-print-preferences-dialog')
}

// start with stock project
app.activeProject = makeVisitorBeam()
app.initialize(app.activeProject)
app.draw(app.activeProject)
document.dispatchEvent(new CustomEvent('project-loaded', { detail: app.activeProject }))

// project list click handlers
document.getElementById('project-list-new-project').onclick = () => { app.onNewProjectClick() }
document.getElementById('project-list-new-folder').onclick = () => { app.onNewFolderClick() }
document.getElementById('move-file-new-folder-button').onclick = () => { app.onNewFolderClick() }

// file menu click handlers
document.getElementById('file-menu-new-file').onclick = () => { app.onNewProjectClick() }
document.getElementById('file-menu-open-file').onclick = () => { app.onOpenFileExplorerClick() }
document.getElementById('file-menu-save-file').onclick = () => { app.onSaveProjectClick() }
document.getElementById('file-menu-copy-file').onclick = () => { app.onCopyFileClick() }
document.getElementById('file-menu-rename-file').onclick = () => { app.onRenameProjectClick() }
document.getElementById('file-menu-move-file').onclick = () => { app.onMoveFileClick() }
document.getElementById('file-menu-print-file').onclick = () => { app.onPrintProject() } 
document.getElementById('file-menu-delete-file').onclick = () => { app.onDeleteProjectClick() }


document.getElementById('english-units-selector').onclick = () => { onEnglishUnitsClicked() }
document.getElementById('english-lbs-units-selector').onclick = () => { onEnglishLbsUnitsClicked() }
document.getElementById('metric-units-selector').onclick = () => { onMetricUnitsClicked() }

function handleQueryParameters() {
    var queryStr = window.location.search;
    var paramPairs = queryStr.substr(1).split('&');
    var params = {};

    for (var i = 0; i < paramPairs.length; i++) {
        var parts = paramPairs[i].split('=');
        params[parts[0]] = parts[1];
        // ./beam-designer.html?login=true
        if (parts[0] == 'login' && parts[1] == 'true') {
            openSigninModal();
        } else if (parts[0] == 'sign-up' && parts[1] == 'true') {
            openSignupModal();
        }
    }
}

window.onbeforeprint = function () {
  drawBeamModel(app.activeProject, true)
  drawResultsView(app.activeProject, gResults, true)
}

window.onafterprint = function () {
  drawBeamModel(app.activeProject, false)
  drawResultsView(app.activeProject, gResults, false)
}

//window.onbeforeunload = () => {
//    return 'Your project needs to be saved. If you leave before saving, your changes will be lost.'
//}

document.addEventListener('customer-logged-out', () => {
  app.activeProject = makeVisitorBeam()
  app.draw(app.activeProject)
  document.dispatchEvent(new CustomEvent('project-loaded', { detail: app.activeProject }))
})

document.addEventListener('analysis-started', () => {
  document.getElementById("design-summary-div").classList.add('d-none')
  document.getElementById("result-view-section").classList.add('d-none')
  document.getElementById('calculating-spinner').classList.remove('d-none')
})

document.addEventListener('analysis-failed', (event) => {
  document.getElementById("result-view-section").classList.add('d-none')
  document.getElementById('calculating-spinner').classList.add('d-none')
})

document.addEventListener('design-failed', (event) => {
  document.getElementById('calculating-spinner').classList.add('d-none')
  //let message = event.detail
  //console.log(message)
})

document.addEventListener('analysis-completed', (event) => {
    let results = event.detail
    gResults = results

    document.getElementById('calculating-spinner').classList.add('d-none')
    document.getElementById("design-summary-div").classList.remove('d-none')
    document.getElementById("result-view-section").classList.remove('d-none')
    suggestShape(app.activeProject, results).then(shape => {
      if (shape) {
        showSuggestedShapeButton(app.activeProject, shape)
      } else {
        hideSuggestedShapeButton()
      }
    })
    showDesignSummary(app.activeProject, results)
    drawResultsView(app.activeProject, results, false)
    showReactionSummary(app.activeProject, results)
    showResultPlots(app.activeProject, results, false)
})

function showSuggestedShapeButton(project, suggestedShape) {
  const button = document.getElementById('suggested-shape-button')
  button.classList.remove('d-none')
  button.innerHTML = `Try ${shapeName(suggestedShape)}`
  button.onclick = () => {
    if(project.isNorthAmericanSteel) {
      designConfigurator.northAmericanSteelShape = suggestedShape
      designConfigurator.northAmericanSteelSelected()
    } else if(project.isWood) {
      designConfigurator.woodShape = suggestedShape
      designConfigurator.woodSelected()
    } else if(project.isEngineeredLumber) {
      designConfigurator.engineeredLumberShape = suggestedShape
      designConfigurator.engineeredLumberSelected()
    }
    onShapeOrMaterialChanged()
    hideSuggestedShapeButton()
  }
}

function hideSuggestedShapeButton() {
  const button = document.getElementById('suggested-shape-button')
  button.classList.add('d-none')
  button.innerHTML = ''
  button.onclick = null
}

function setBeamDesignUnsaved() {
  app.activeProject.isModified = true;
  // triggers analyze()
  document.dispatchEvent(new CustomEvent('project-modified'))
}

document.addEventListener('units-changed', () => {
  updateActionCards()
  app.draw(app.activeProject)
  setBeamDesignUnsaved()
})

document.addEventListener('project-loaded', () => {
  updateActionCards()
  //setBeamDesignUnsaved()
  // update design configurator with LRFD or ASD
  if(app.activeProject.isLRFD) {
    designConfigurator.lrfdCombinationsSelected()
  } else if(app.activeProject.isASD) {
    designConfigurator.asdCombinationsSelected()
  } else {
    // design type is None
  }
})

// /*****************************
//  * Action Cards
//  ****************************/
function updateActionCards() {
  document.getElementById('material-panel-text').innerHTML = app.activeProject.materialName
  let str = app.activeProject.shapeName
  if(app.activeProject.isEngineeredLumber === false) {
      const shapeIString = app.activeProject.beam.crossSectionRotation === 0 ? app.activeProject.shapeIxString : app.activeProject.shapeIyString
      str += ` (${shapeIString})`
  }
  document.getElementById('shape-panel-text').innerHTML = str
  document.getElementById('design-panel-text').innerHTML = app.activeProject.designTypeStr
  document.getElementById('span-panel-text').innerHTML = app.activeProject.spanStr
  document.getElementById('load-panel-text').innerHTML = app.activeProject.loadStr
  document.getElementById('bracing-panel-text').innerHTML = app.activeProject.bracingStr
    
  // temporary - udate material and shape dialog headers
  const shapeName = app.activeProject.shapeName
  const materialName = app.activeProject.isCustom ||  app.activeProject.isEngineeredLumber ? "" : app.activeProject.materialName;
  document.getElementById('current-selected-shape').innerHTML = `${shapeName} ${materialName}`
  document.getElementById('material-selected-shape').innerHTML = `${shapeName} ${materialName}`
    
  // temporary - update rotation button visibility
  if(app.activeProject.shapeCanBeRotated) {
      document.getElementById("beam-rotation-button-group").classList.remove("d-none")
  } else {
      document.getElementById("beam-rotation-button-group").classList.add("d-none")
  }
}

/***********************************
 **** Shape and material dialog ****
 ***********************************/

document.addEventListener('DOMContentLoaded', (event) => {
  const shapeModal = document.getElementById('modal-shape-selector-dialog');

  shapeModal.addEventListener('shown.bs.modal', (event) => {
    // Set the correct pill to active
    const shapeCategory = app.activeProject.shapeCategory; // Assuming shapeCategory is a property of activeProject
    let pillId;

    switch (shapeCategory) {
      case 'north-american-steel':
        pillId = 'north-american-shapes-button';
        break;
      case 'dimensional-lumber':
        pillId = 'wood-shapes-button';
        break;
      case 'engineered-wood':
        pillId = 'engineered-wood-shapes-button';
        break;
      case 'european-steel':
        pillId = 'european-shapes-button';
        break;
      case 'custom':
        pillId = 'custom-shapes-button';
        break;
      default:
        pillId = 'north-american-shapes-button'; // Default to North American Steel if category is unknown
    }
    setActivePill(pillId); // Change this to the ID of the pill you want to activate
  });
});

document.addEventListener('north-american-steel-shape-selected', (event) => {
    const shape = event.detail
    designConfigurator.northAmericanSteelShape = shape
    designConfigurator.northAmericanSteelSelected()
    document.getElementById('use-custom-shape').checked = false
    onShapeOrMaterialChanged()
})

document.addEventListener('european-steel-shape-selected', (event) => {
    if (featureGate()) { return; }
    const shape = event.detail
    designConfigurator.europeanSteelShape = shape;
    designConfigurator.europeanSteelSelected()
    document.getElementById('use-custom-shape').checked = false
    onShapeOrMaterialChanged()
})

document.addEventListener('wood-shape-selected', (event) => {
    const shape = event.detail
    designConfigurator.woodShape = shape
    designConfigurator.woodSelected()
    document.getElementById('use-custom-shape').checked = false
    onShapeOrMaterialChanged()
})

document.addEventListener('engineered-lumber-shape-selected', (event) => {
    if (featureGate()) { return; }
    const shape = event.detail
    designConfigurator.engineeredLumberShape = shape
    designConfigurator.engineeredLumberSelected()
    document.getElementById('use-custom-shape').checked = false
    onShapeOrMaterialChanged()
})

document.addEventListener('flitch-updated', (event) => {
  if (featureGate()) { return; }
    const flitch = event.detail
    if (app.activeProject.isWood) {
        if (flitch) {
            designConfigurator.woodShape.flitch = flitch
        } else {
            delete designConfigurator.woodShape.flitch
        }
        designConfigurator.woodSelected()
    } else if (app.activeProject.isEngineeredLumber) {
        if (flitch) {
            designConfigurator.engineeredLumberShape.flitch = flitch
        } else {
            delete designConfigurator.engineeredLumberShape.flitch
        }
        designConfigurator.engineeredLumberSelected()
    }
    onShapeOrMaterialChanged()
})

document.addEventListener('custom-soldier-shape-selected', (event) => {
    if (featureGate()) { return; }
    const shape = event.detail
    designConfigurator.customSoldierShape = shape;
    designConfigurator.customSoldierSelected();
    document.getElementById('use-custom-shape').checked = false
    onShapeOrMaterialChanged()
})

document.addEventListener('custom-aluminum-shape-selected', (event) => {
    if (featureGate()) { return; }
    const shape = event.detail
    designConfigurator.customAluminumShape = shape;
    designConfigurator.customAluminumSelected();
    document.getElementById('use-custom-shape').checked = false
    onShapeOrMaterialChanged()
})

document.addEventListener('custom-shape-selected', (event) => {
    if (featureGate()) { return; }
    const shape = event.detail
    designConfigurator.customShape = shape
    designConfigurator.customMaterial = shape // (custom shapes also include material)
    designConfigurator.customShapeSelected()
    onShapeOrMaterialChanged()
})

document.addEventListener('custom-shape-unselected', () => {
    if (featureGate()) { return; }
    designConfigurator.northAmericanSteelSelected();
    onShapeOrMaterialChanged()
})

document.addEventListener('north-american-steel-material-selected', (event) => {
    const material = event.detail
    designConfigurator.northAmericanSteelMaterial = material;
    designConfigurator.northAmericanSteelSelected();
    onShapeOrMaterialChanged()
})

document.addEventListener('european-steel-material-selected', (event) => {
    if (featureGate()) { return; }
    const material = event.detail
    designConfigurator.europeanSteelMaterial = material;
    designConfigurator.europeanSteelSelected();
    onShapeOrMaterialChanged()
})

document.addEventListener('astm-steel-material-selected', (event) => {
    if (featureGate()) { return; }
    const material = event.detail
    designConfigurator.customSoldierMaterial = material;
    designConfigurator.customSoldierSelected();
    onShapeOrMaterialChanged()
})

document.addEventListener('aluminum-material-selected', (event) => {
    if (featureGate()) { return; }
    const material = event.detail
    designConfigurator.customAluminumMaterial = material;
    designConfigurator.customAluminumSelected();
    onShapeOrMaterialChanged()
})

document.addEventListener('wood-material-selected', (event) => {
    const material = event.detail
    designConfigurator.woodMaterial = material
    designConfigurator.woodSelected()
    onShapeOrMaterialChanged()
})

document.addEventListener('plies-changed', (event) => {
    if(featureGate()) { 
        hideBootstrapModal('modal-shape-selector-dialog')
        return 
    }
    BeamManager.updateNumberOfPlys(app.activeProject, event.detail)
    updateActionCards()
    drawBeamModel(app.activeProject, false)
    setBeamDesignUnsaved()
})

function onShapeOrMaterialChanged() {
  console.log("shape or material changed")
  designConfigurator.setShapeMaterialAndDesign(app.activeProject)
  gResults = []
  updateActionCards()
  drawBeamModel(app.activeProject, false)
  document.dispatchEvent(new CustomEvent('shape-or-material-changed', {detail: app.activeProject}))
  setBeamDesignUnsaved()
}

document.getElementById('beam-rotation-0-degrees-button').onclick = () => {
  if(featureGate()) { return }
  app.activeProject.beam.crossSectionRotation = 0
  // update the cross section drawing
  drawBeamModel(app.activeProject, false)
  
}

document.getElementById('beam-rotation-90-degrees-button').onclick = () => {
  if(featureGate()) { return }
  app.activeProject.beam.crossSectionRotation = 90
  // update the cross section drawing
  drawBeamModel(app.activeProject, false)
}

// /***********************
//  **** Design dialog ****
//  **********************/
document.getElementById('lrfd-combinations-button').onclick = () => {
    app.activeProject.design.designType = 'LRFD'
    app.activeProject.design.loadCombination = lrfdCombinations
    designConfigurator.lrfdCombinationsSelected()
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: app.activeProject}))
    updateActionCards()
    setBeamDesignUnsaved()
}

document.getElementById('asd-combinations-button').onclick = () => {
    app.activeProject.design.designType = 'ASD'
    app.activeProject.design.loadCombination = asdCombinations
    designConfigurator.asdCombinationsSelected()
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: app.activeProject}))
    updateActionCards()
    setBeamDesignUnsaved()
}

document.getElementById('no-combinations-button').onclick = () => {
    app.activeProject.design.designType = 'None'
    app.activeProject.design.loadCombination = noCombinations
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: app.activeProject}))
    updateActionCards()
    setBeamDesignUnsaved()
}

document.getElementById('use-load-combo-equations').onclick = () => {
    const useEquations = document.getElementById('use-load-combo-equations').checked
    if(useEquations === false) {
      app.activeProject.design.loadCombination = noCombinations;
    } else if(app.activeProject.isLRFD) {
      app.activeProject.design.loadCombination = lrfdCombinations;
    } else if(app.activeProject.isASD) {
      app.activeProject.design.loadCombination = asdCombinations;
    }
    document.dispatchEvent(new CustomEvent('use-load-combo-did-change', {detail: app.activeProject}))
    setBeamDesignUnsaved()
}

document.getElementById('use-lambda-or-cd').onclick = () => {
  if(featureGate()) { return }
    let useLambda = document.getElementById('use-lambda-or-cd').checked
    app.activeProject.design.useLambdaOrCd = useLambda
    document.dispatchEvent(new CustomEvent('use-lambda-or-cd-did-change', {detail: app.activeProject}))
    setBeamDesignUnsaved()
}

document.addEventListener('lambda-or-cd-changed', (event) => {
  if(featureGate()) { return }
  app.activeProject.design.updateLambdaOrCd(event.detail.equationName, event.detail.value)
  setBeamDesignUnsaved()
})

document.getElementById('use-repetitive-member-factor').onclick = () => {
  if(featureGate()) { return }
    let useRepetitiveMemberFactor = document.getElementById('use-repetitive-member-factor').checked
    app.activeProject.design.useRepetitiveMemberFactor = useRepetitiveMemberFactor
    setBeamDesignUnsaved()
}

document.addEventListener('toggle-load-combination-equation', (event) => {
  app.activeProject.design.loadCombination.togglePrettyExclude(event.detail)
  setBeamDesignUnsaved()
})

document.addEventListener('design-deflection-limits-changed', (event) => {
    const deflectionLimits = event.detail
    app.activeProject.design.liveLoadLimit = deflectionLimits.liveLoadLimit
    app.activeProject.design.deadPlusLiveLoadLimit = deflectionLimits.deadPlusLiveLoadLimit
    app.activeProject.design.snowOrWindLoadLimit = deflectionLimits.snowOrWindLoadLimit
    app.activeProject.design.totalLoadLimit = deflectionLimits.totalLoadLimit
    setBeamDesignUnsaved()
})

// /***********************
//  **** Span dialog ****
//  **********************/
document.getElementById('add-left-span-button').onclick = () => { 
  if(checkIsUpgraded() === false && app.activeProject.beam.spans.length > 1) { 
    featureGate()
    hideBootstrapModal('modal-span-dialog')
    return 
  }
  const length = app.activeProject.beam.spans[0].length()
  if(!isNaN(length) && BeamManager.addLeftSpan(app.activeProject, length)) {
    document.dispatchEvent(new CustomEvent('spans-did-change', {detail: app.activeProject}))
    drawBeamModel(app.activeProject, false)
    setBeamDesignUnsaved()
  }
}

document.getElementById('add-right-span-button').onclick = () => { 
  if(checkIsUpgraded() === false && app.activeProject.beam.spans.length > 1) { 
    featureGate()
    hideBootstrapModal('modal-span-dialog')
    return 
  }
  const length = app.activeProject.beam.spans[app.activeProject.beam.spans.length - 1].length();
  if(!isNaN(length) && BeamManager.addRightSpan(app.activeProject, length)) {
    document.dispatchEvent(new CustomEvent('spans-did-change', {detail: app.activeProject}))
    drawBeamModel(app.activeProject, false)
    setBeamDesignUnsaved()
  }
}

document.addEventListener('remove-span', (event) => {
  if(BeamManager.removeSpan(app.activeProject, event.detail)) {
    document.dispatchEvent(new CustomEvent('spans-did-change', {detail: app.activeProject}))
    drawBeamModel(app.activeProject, false)
    setBeamDesignUnsaved()
  }
})

document.addEventListener('span-length-changed', (event) => {
    const index = event.detail
    const spanId = `span-input-${index}`
    if(validateRequiredInput(spanId) && validateLengthInput(spanId) && validateGreaterThan(spanId, 0.0)) {
      const length = wsParseLength(document.getElementById(spanId).value)
      BeamManager.modifySpan(app.activeProject, index, length)
      document.dispatchEvent(new CustomEvent('spans-did-change', {detail: app.activeProject}))
      drawBeamModel(app.activeProject, false)
      setBeamDesignUnsaved()
    }
})

document.addEventListener('spans-did-change', () => {
    // update span button
    document.getElementById('span-panel-text').innerHTML = app.activeProject.beam.spans.length === 1 ? "1 Span" : app.activeProject.beam.spans.length + " Spans"
})

document.addEventListener('on-support-clicked', (event) => {
    let isStable = BeamManager.cycleSupport(app.activeProject, event.detail)
    drawBeamModel(app.activeProject, false)
    if(isStable) {
      setBeamDesignUnsaved()
    }
})

// /*********************
//  **** Load dialog ****
//  *********************/

function onLoadSavedOrDeleted() {
  drawBeamModel(app.activeProject, false)
  document.dispatchEvent( new CustomEvent('loads-changed', { detail: app.activeProject } ))
  updateActionCards()
  setBeamDesignUnsaved()
}

document.getElementById('load-precision-two-decimals').onclick = () => {
  if(featureGate()) { 
      hideBootstrapModal('modal-load-dialog')
      return 
  }
  app.activeProject.loadPrecision = 2
  document.getElementById("load-precision-dropdown").innerHTML = "Load Precision: 2 decimal places"
  onLoadSavedOrDeleted()
}

document.getElementById('load-precision-three-decimals').onclick = () => {
  if(featureGate()) { 
      hideBootstrapModal('modal-load-dialog')
      return 
  }
  app.activeProject.loadPrecision = 3
  document.getElementById("load-precision-dropdown").innerHTML = "Load Precision: 3 decimal places"
  onLoadSavedOrDeleted()
}

document.getElementById('self-weight-checkbox').onclick = () => {
  app.activeProject.design.includeSelfWeight = document.getElementById('self-weight-checkbox').checked
  drawBeamModel(app.activeProject, false)
  setBeamDesignUnsaved()
}

document.addEventListener('save-point-load', (event) => {
  const l = event.detail
  if(typeof l.index === 'undefined') {
    LoadManager.addPointLoad(app.activeProject, l.x, l.D, l.L, l.Lr, l.S, l.W, l.E, l.H, l.R, l.isMoment)
  } else {
    LoadManager.modifyPointLoad(app.activeProject, l.index, l.x, l.D, l.L, l.Lr, l.S, l.W, l.E, l.H, l.R, l.isMoment)
  }
  onLoadSavedOrDeleted()
})

document.addEventListener('save-distributed-load', (event) => {
  const l = event.detail
  if(typeof l.index === 'undefined') {
    LoadManager.addDistLoad(app.activeProject, l.x1, l.x2, l.D, l.L, l.Lr, l.S, l.W, l.E, l.H, l.R, 
      l.D2, l.L2, l.Lr2, l.S2, l.W2, l.E2, l.H2, l.R2, l.isLinear)
  } else {
    LoadManager.modifyDistLoad(app.activeProject, l.index, l.x1, l.x2, l.D, l.L, l.Lr, l.S, l.W, l.E, l.H, l.R, 
      l.D2, l.L2, l.Lr2, l.S2, l.W2, l.E2, l.H2, l.R2, l.isLinear)
  }
  onLoadSavedOrDeleted()
})

document.addEventListener('delete-point-load', (event) => {
  LoadManager.removePointLoad(app.activeProject, event.detail)
  onLoadSavedOrDeleted()
})

document.addEventListener('delete-distributed-load', (event) => {
  LoadManager.removeDistLoad(app.activeProject, event.detail)
  onLoadSavedOrDeleted()
})

// /************************
//  **** Bracing dialog ****
//  ***********************/
document.getElementById('continuous-bracing-button').onclick = () => { 
  BracingManager.updateBracingType(app.activeProject, 'continuous')
  updateActionCards()
  drawBeamModel(app.activeProject, false)
  setBeamDesignUnsaved()
}

document.getElementById('equally-spaced-bracing-button').onclick = () => { 
  BracingManager.updateBracingType(app.activeProject, 'equal')
  updateActionCards()
  drawBeamModel(app.activeProject, false)
  setBeamDesignUnsaved()
}

document.getElementById('custom-bracing-button').onclick = () => {
  BracingManager.updateBracingType(app.activeProject, 'custom') 
  updateActionCards()
  drawBeamModel(app.activeProject, false)
  setBeamDesignUnsaved()
}

document.getElementById('unbraced-bracing-button').onclick = () => { 
  BracingManager.updateBracingType(app.activeProject, 'unbraced')
  updateActionCards()
  drawBeamModel(app.activeProject, false)
  setBeamDesignUnsaved()
}

document.addEventListener('equal-space-bracing-changed', (event) => { 
  BracingManager.addEquallySpacedBraces(app.activeProject, event.detail.braceSpacing, event.detail.braceStart)
  updateActionCards()
  drawBeamModel(app.activeProject, false)
  setBeamDesignUnsaved()
})

document.addEventListener('add-new-brace', (event) => { 
  if (BracingManager.addBrace(app.activeProject, event.detail, false)) {
    document.dispatchEvent(new CustomEvent('bracing-did-change', {detail: app.activeProject}))
    updateActionCards()
    drawBeamModel(app.activeProject, false)
    setBeamDesignUnsaved()
  }
})

document.addEventListener('remove-brace', (event) => {
  if (BracingManager.removeBrace(app.activeProject, event.detail)) {
    document.dispatchEvent(new CustomEvent('bracing-did-change', {detail: app.activeProject}))
    updateActionCards()
    drawBeamModel(app.activeProject, false)
    setBeamDesignUnsaved()
  }
})

initializeTooltips()

// add text box and button to bottom
// read user configs to see if this feature is enabled
//const exportComponent = document.createElement('file-export-component')
//document.getElementById("export-component-div").appendChild(exportComponent)